export default __webpack_public_path__ + "static/media/Whole School Day flyer.68af349f.pdf";